import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { readConsent, grantConsent, denyConsent, isPrerender } from "helpers/analytics.js";
import { css } from "styled-components/macro"; //eslint-disable-line

const BannerContainer = styled.div`
  ${tw`fixed bottom-0 left-0 right-0 z-50 bg-black text-white text-sm px-4 py-3 flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6`}
`;

const Actions = tw.div`flex items-center gap-3 flex-shrink-0`;
const AcceptButton = tw.button`
  bg-primary-500 hover:bg-primary-700 text-white font-semibold px-4 py-2 rounded transition duration-300
`;

const RejectButton = tw.button`
  bg-gray-700 hover:bg-gray-600 text-white font-semibold px-4 py-2 rounded transition duration-300
`;

const LearnMoreLink = tw.a`
  text-gray-300 hover:text-white underline
`;

const CookieBanner = () => {
  // Start hidden, then show after mount if this visitor has made no choice.
  // react-snap runs effects during prerender, so without the isPrerender guard
  // the banner would be baked into every static page and flash on hydration
  // for visitors who have already answered it.
  const [showBanner, setShowBanner] = React.useState(false);

  React.useEffect(() => {
    if (!isPrerender() && readConsent() === null) setShowBanner(true);
  }, []);

  const handleAccept = () => {
    grantConsent();
    setShowBanner(false);
  };

  const handleReject = () => {
    denyConsent();
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <BannerContainer>
      <span tw="text-center sm:text-left">
        We use optional analytics cookies to understand how the site is used. No
        analytics cookies are set unless you accept.
      </span>
      <Actions>
        <AcceptButton onClick={handleAccept}>Accept</AcceptButton>
        <RejectButton onClick={handleReject}>Reject</RejectButton>
        <LearnMoreLink href="/privacy-policy">Learn more</LearnMoreLink>
      </Actions>
    </BannerContainer>
  );
};

export default CookieBanner;